module.exports = __webpack_public_path__ + "img/shop-icon.79cae82e.svg";